import { AlchemyProvider } from "../types";

const rinkeby = localStorage.getItem("rinkeby");
const IS_RINKEBY = Boolean(rinkeby);
// const IS_RINKEBY = true;

const ABI_JSON = require("./ABI.json");
const ABI_RINKEBY_JSON = require("./ABI_RINKEBY.json");

const ProdConfig = {
  contractId: "0x464484E2D03c9567908C7D1C755E56a75D91FCaf",
  abi: ABI_JSON,
};

const RinkebyConfig = {
  contractId: "0xbea64ccCAaE569B1f54d3710d8271eF40dB24E9f",
  abi: ABI_RINKEBY_JSON,
};

/**
 * Ссылка на дефолтного провайдера infura
 */
const INFURA_PROVIDER_LINK = "https://ethereum.sadgirlsbar.io";

/**
 * Список url-ов для infura, каждый url - отдельное соедение для Web3
 */
const INFURA_PROVIDERS = [INFURA_PROVIDER_LINK];

/**
 * Идентификатор контракта
 */
const CONTRACT_ID = IS_RINKEBY
  ? RinkebyConfig.contractId
  : ProdConfig.contractId;

/**
 * Цена в Ethereum
 */
const PRICE_IN_ETHEREUM = "20000000000000000000";
const SINGLE_ETHEREUM = "1000000000000000000";

/**
 * Максимальное количество токенов при единоразовой покупке
 */
const MAX_TOKENS = 20;

const query = new URLSearchParams(window.location.search);

/**
 * Показывать форму buy, даже если isStarted = false (query: forceBuyForm=true)
 */
const FORCE_SHOW_BUY_FORM = query.get("forceBuyForm") || false;

/**
 * Тип сервиса для работы с сетью Ethereum
 * web3 - библиотека web3
 * ethers - библиотека ethers
 */
type EthereumService = "web3" | "ethers";
const DEFAULT_ETHEREUM_SERVICE: EthereumService = "web3";

export {
  ABI_JSON,
  INFURA_PROVIDERS,
  INFURA_PROVIDER_LINK,
  PRICE_IN_ETHEREUM,
  CONTRACT_ID,
  SINGLE_ETHEREUM,
  MAX_TOKENS,
  FORCE_SHOW_BUY_FORM,
  DEFAULT_ETHEREUM_SERVICE,
};
